import React from 'react';
import { SurveyInviteModal } from './SurveyInviteModal';

export const SurveyInviteGate: React.FC = () => {
  return <SurveyInviteModal />;
};
